/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CarInputs */

const en_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Car`)
};

const es_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coche`)
};

const fr_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voiture`)
};

const de_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const ja_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動車`)
};

const zh_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轿车`)
};

const ar_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيارة`)
};

const id_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mobil`)
};

const it_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

const ru_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Легковой автомобиль`)
};

const pt_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carro`)
};

const ko_val_car = /** @type {(inputs: Val_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`승용차`)
};

/**
* | output |
* | --- |
* | "Car" |
*
* @param {Val_CarInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_car = /** @type {((inputs?: Val_CarInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CarInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_car(inputs)
	if (locale === "es") return es_val_car(inputs)
	if (locale === "fr") return fr_val_car(inputs)
	if (locale === "de") return de_val_car(inputs)
	if (locale === "ja") return ja_val_car(inputs)
	if (locale === "zh") return zh_val_car(inputs)
	if (locale === "ar") return ar_val_car(inputs)
	if (locale === "id") return id_val_car(inputs)
	if (locale === "it") return it_val_car(inputs)
	if (locale === "ru") return ru_val_car(inputs)
	if (locale === "pt") return pt_val_car(inputs)
	return ko_val_car(inputs)
});